import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {

  meterActivationData: null,
  errors: null,
  loader: false,
  success: false,

  assignInspectorCompanyData : null,
  
  assignContractorData: null,

  assignTechnicianData: null,

  managementDecisionData: null,

  awaitingInspectorData: null,

  qualityControlData: null,

  failedExecutionData: null,
};

export default function myWorkspaceReducer(state = initialState, action) {
  switch (action.type) {
    // workspace - pending meter activation
    case ACTIONS_TYPES.METER_ACTIVATION_REQUEST:
      console.log("in reducer METER_ACTIVATION_REQUEST");
      
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.METER_ACTIVATION_SUCCESS:
        console.log("in reducer success");

      return { ...state, meterActivationData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.METER_ACTIVATION_FAILED:
        console.log("in reducer METER_ACTIVATION_FAILED");

      return { ...state, loader: false, errors: action.payload };

    //workspace - awaiting contractor
    case ACTIONS_TYPES.ASSIGN_CONTRACTOR_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.ASSIGN_CONTRACTOR_SUCCESS:
      return { ...state, assignContractorData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.ASSIGN_CONTRACTOR_FAILED:
      return { ...state, loader: false, errors: action.payload };

      //workspace - awaiting contractor
      case ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_SUCCESS:
      return { ...state, assignInspectorCompanyData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.ASSIGN_INSPECTOR_COMPANY_FAILED:
      return { ...state, loader: false, errors: action.payload };

      //workspace - awaiting technician
    case ACTIONS_TYPES.ASSIGN_TECHNICIAN_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.ASSIGN_TECHNICIAN_SUCCESS:
      return { ...state, assignTechnicianData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.ASSIGN_TECHNICIAN_FAILED:
      return { ...state, loader: false, errors: action.payload };
   

      //workspace - management-decision
    case ACTIONS_TYPES.MANAGEMENT_DECISION_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.MANAGEMENT_DECISION_SUCCESS:
      return { ...state, managementDecisionData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.MANAGEMENT_DECISION_FAILED:
      return { ...state, loader: false, errors: action.payload };
   
      //workspace - awaiting-inspector
    case ACTIONS_TYPES.AWAITING_INSPECTOR_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.AWAITING_INSPECTOR_SUCCESS:
      return { ...state, awaitingInspectorData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.AWAITING_INSPECTOR_FAILED:
      return { ...state, loader: false, errors: action.payload };

    //workspace - quality-control
    case ACTIONS_TYPES.QUALITY_CONTROL_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.QUALITY_CONTROL_SUCCESS:
      return { ...state, qualityControlData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.QUALITY_CONTROL_FAILED:
      return { ...state, loader: false, errors: action.payload };

    //workspace - failed-execution
    case ACTIONS_TYPES.FAILED_EXECUTION_REQUEST:
      return { ...state, loader: true, errors: null, success: false };

    case ACTIONS_TYPES.FAILED_EXECUTION_SUCCESS:
      return { ...state, failedExecutionData: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.FAILED_EXECUTION_FAILED:
      return { ...state, loader: false, errors: action.payload };

    case ACTIONS_TYPES.MY_WORKSPACE_RESET:
      return { ...initialState };

    default:
      return state;
  }
}